import { string } from 'yup';

export const ts = {
  TOASTR_PASS_ADDED: {
    description: '{{passType}} pass added',
    primaryValue: '{{passType}} pass added',
    stringKey: 'TOASTR_PASS_ADDED',
  },
  TOASTR_CHANGES_SAVED: {
    description: 'Changes Saved',
    primaryValue: 'Changes Saved',
    stringKey: 'TOASTR_CHANGES_SAVED',
  },
  TOASTR_PASS_ERROR: {
    description: 'There was an error adding your pass.',
    primaryValue: 'There was an error adding your pass.',
    stringKey: 'TOASTR_PASS_ERROR',
  },
  PASS_MODAL_REGISTER: {
    description: 'Register',
    primaryValue: 'Register',
    stringKey: 'PASS_MODAL_REGISTER',
  },
  PASS_MODAL_VENDOR_INFO_HEADING: {
    description: 'Vendor Info',
    primaryValue: 'Vendor Info',
    stringKey: 'PASS_MODAL_VENDOR_INFO_HEADING',
  },
  PLACEHOLDER_VENDOR_CODE_COMPANY_NAME: {
    description: 'Vendor Code/Company Name',
    primaryValue: 'Vendor Code/Company Name',
    stringKey: 'PLACEHOLDER_VENDOR_CODE_COMPANY_NAME',
  },
  DDL_STORE_SELECT: {
    description: 'Select Store',
    primaryValue: 'Select Store',
    stringKey: 'DDL_STORE_SELECT',
  },
  PASS_MODAL_STORE_HEADING: {
    description: 'Store',
    primaryValue: 'Store',
    stringKey: 'PASS_MODAL_STORE_HEADING',
  },
  PASS_MODAL_DATE_RANGE_HEADING: {
    description: 'Date Range',
    primaryValue: 'Date Range',
    stringKey: 'PASS_MODAL_DATE_RANGE_HEADING',
  },
  GRID_EMPTY_TEXT_VENDOR: {
    description: 'No vendors added',
    primaryValue: 'No vendors added...',
    stringKey: 'GRID_EMPTY_TEXT_VENDOR',
  },
  PASS_MODAL_VENDOR_HEADING: {
    description: 'Vendor',
    primaryValue: 'Vendor',
    stringKey: 'PASS_MODAL_VENDOR_HEADING',
  },
  PLACEHOLDER_WE_CHAT_ID: {
    description: 'WeChat ID',
    primaryValue: 'WeChat ID',
    stringKey: 'PLACEHOLDER_WE_CHAT_ID',
  },
  PASS_MODAL_WE_CHAT_ERROR: {
    description: 'One of the following required: WeChat ID or Email',
    primaryValue: 'One of the following required: WeChat ID or Email',
    stringKey: 'PASS_MODAL_WE_CHAT_ERROR',
  },
  BULK_UPLOAD_LIST_HEADER: {
    description: 'Bulk Upload List',
    primaryValue: 'Bulk List',
    stringKey: 'BULK_UPLOAD_LIST_HEADER',
  },
  PLACEHOLDER_BULK_UPLOAD: {
    description: 'Paste the data from your spreadsheet here',
    primaryValue: 'Paste the data from your spreadsheet here',
    stringKey: 'PLACEHOLDER_BULK_UPLOAD',
  },
  BULK_UPLOAD_PASTE: {
    description: 'Paste into the box to the right',
    primaryValue: 'Paste into the box to the right',
    stringKey: 'BULK_UPLOAD_PASTE',
  },
  BULK_UPLOAD_COPY: {
    description: 'Copy the data from the spreadsheet',
    primaryValue: 'Copy the data from the spreadsheet',
    stringKey: 'BULK_UPLOAD_COPY',
  },
  BULK_UPLOAD_FORMAT: {
    description: 'Format your spreadsheet in Excel',
    primaryValue: 'Format your spreadsheet in Excel',
    stringKey: 'BULK_UPLOAD_FORMAT',
  },
  BULK_UPLOAD_FORMAT_DIRECTIONS: {
    description:
      'First name in the first column, last name in the second, and email in the third. (See example above)',
    primaryValue:
      'First name in the first column, last name in the second, and email in the third. (See example above)',
    stringKey: 'BULK_UPLOAD_FORMAT_DIRECTIONS',
  },
  BULK_UPLOAD_DATA_1_1: {
    description: 'John',
    primaryValue: 'John',
    stringKey: 'BULK_UPLOAD_DATA_1_1',
  },
  BULK_UPLOAD_DATA_1_2: {
    description: 'Smith',
    primaryValue: 'Smith',
    stringKey: 'BULK_UPLOAD_DATA_1_2',
  },
  BULK_UPLOAD_DATA_1_3: {
    description: 'john@email.com',
    primaryValue: 'john@email.com',
    stringKey: 'BULK_UPLOAD_DATA_1_3',
  },
  BULK_UPLOAD_DATA_2_1: {
    description: 'jane',
    primaryValue: 'jane',
    stringKey: 'BULK_UPLOAD_DATA_2_1',
  },
  BULK_UPLOAD_DATA_2_2: {
    description: 'smith',
    primaryValue: 'smith',
    stringKey: 'BULK_UPLOAD_DATA_2_2',
  },
  BULK_UPLOAD_DATA_2_3: {
    description: 'jane@email.com',
    primaryValue: 'jane@email.com',
    stringKey: 'BULK_UPLOAD_DATA_2_3',
  },
  BULK_UPLOAD_COL_HEADER_A: {
    description: 'A',
    primaryValue: 'A',
    stringKey: 'BULK_UPLOAD_COL_HEADER_A',
  },
  BULK_UPLOAD_COL_HEADER_B: {
    description: 'B',
    primaryValue: 'B',
    stringKey: 'BULK_UPLOAD_COL_HEADER_B',
  },
  BULK_UPLOAD_COL_HEADER_C: {
    description: 'C',
    primaryValue: 'C',
    stringKey: 'BULK_UPLOAD_COL_HEADER_C',
  },
  BULK_UPLOAD_INSTRUCTIONS: {
    description: 'Instructions',
    primaryValue: 'Instructions',
    stringKey: 'BULK_UPLOAD_INSTRUCTIONS',
  },
  BTN_CANCEL: {
    description: 'Cancel',
    primaryValue: 'Cancel',
    stringKey: 'BTN_CANCEL',
  },
  BULK_UPLOAD_ROWS_ERROR: {
    description: 'Error processing rows',
    primaryValue: 'Error processing rows',
    stringKey: 'BULK_UPLOAD_ROWS_ERROR',
  },
  BULK_UPLOAD_STRING_ERROR: {
    description: 'Columns should be tab delimited',
    primaryValue: 'Columns should be tab delimited',
    stringKey: 'BULK_UPLOAD_STRING_ERROR',
  },
  BULK_UPLOAD_ROW_ERROR: {
    description: 'Error processing row: ({{rowNumber}})',
    primaryValue: 'Error processing row: ({{rowNumber}})',
    stringKey: 'BULK_UPLOAD_ROW_ERROR',
  },
  BULK_UPLOAD_NAME_EMAIL_ERROR: {
    description: 'Please make sure row has (First Name, Last Name and Email)',
    primaryValue: 'Please make sure row has (First Name, Last Name and Email)',
    stringKey: 'BULK_UPLOAD_NAME_EMAIL_ERROR',
  },
  BULK_UPLOAD_NAME_ERROR: {
    description: 'Please make sure row has (First Name, Last Name)',
    primaryValue: 'Please make sure row has (First Name, Last Name)',
    stringKey: 'BULK_UPLOAD_NAME_ERROR',
  },
  BULK_UPLOAD_FIRST_NAME_ERROR: {
    description: 'Please make sure row has (First Name)',
    primaryValue: 'Please make sure row has (First Name)',
    stringKey: 'BULK_UPLOAD_FIRST_NAME_ERROR',
  },
  BULK_UPLOAD_LAST_NAME_ERROR: {
    description: 'Please make sure row has (Last Name)',
    primaryValue: 'Please make sure row has (Last Name)',
    stringKey: 'BULK_UPLOAD_LAST_NAME_ERROR',
  },
  BULK_UPLOAD_EMAIL_ERROR: {
    description: 'Please make sure row has (Valid Email)',
    primaryValue: 'Please make sure row has (Valid Email)',
    stringKey: 'BULK_UPLOAD_EMAIL_ERROR',
  },
  BULK_UPLOAD_DUP_ERROR: {
    description: 'Row is duplicate',
    primaryValue: 'Row is duplicate',
    stringKey: 'BULK_UPLOAD_DUP_ERROR',
  },
  BULK_UPLOAD_INVALID_ERROR: {
    description: 'Error adding row: Row is not valid',
    primaryValue: 'Error adding row: Row is not valid',
    stringKey: 'BULK_UPLOAD_INVALID_ERROR',
  },
  PASS_MODAL_UPDATE: {
    description: 'Update',
    primaryValue: 'Update',
    stringKey: 'PASS_MODAL_UPDATE',
  },
};
